/*
* Project: LegalPlace assistant
* File: src\components\misc\textarea.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

// modif0
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  initOutputVariable, editVariable, initOutputOption,
} from '../../redux/actions/output';
import LpPopupPreview from '../popup_preview';
import { icSetOption, icSetVariable } from '../../redux/actions/input_context';
import LpHelper from './helper';
import { editedDocument } from '../../redux/actions/account_settings';
import { isDocumentEdited } from '../../globals';
import LpWarning from './warning';
import { lpGetOptionById, lpGetVariableById } from '../../logic/re_index';
import lpApp from '../../app/lp_app';
import ConditionsEvo from '../../logic/condition_evo'


class TextArea extends Component {
  constructor(props) {
    super(props);
    this.changeCallback = this.changeCallback.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.text = '';
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  componentWillMount() {
    if (!this.props.exists) {
      this.props.initOutputSystem(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}`
        : this.props.id,
      this.props.lpKey,
      this.props.ovc,
      '');
    } else {
      this.text = this.props.value;
    }
  }

  componentDidMount() {
    // In case props value is not equal to state value
    // we update it in state (must be a prefilled value)
    if(this.props.value.length > 0 && this.props.value !== lpGetVariableById(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}`
    : this.props.id).value) {
      this.props.changeValue(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}`
      : this.props.id, this.props.value)
    }
  }

  componentWillUpdate(props) {
    this.text = props.value;
    this.changeValue(props.value);
  }

  onBlur() {
    this.props.unUpdateContext();
  }

  onFocus() {
    this.props.updateContext();
  }

  changeCallback(evt) {
    this.props.changeValue(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id, evt.target.value);
  }

  changeValue(value) {
    this.props.changeValue(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id, value);
  }

  render() {
    const variableMeta = lpApp.references.getVariable(this.props.id);

    /*
         * Height personnalisable
         */
    let height = 60;
    if (variableMeta.textarea_size) {
      switch (variableMeta.textarea_size) {
        case 's':
          height = 60;
          break;
        case 'm':
          height = 120;
          break;
        case 'l':
          height = 240;
          break;
        case 'p':
          if (variableMeta.textarea_height
            && !Number.isNaN(parseInt(variableMeta.textarea_height, 10))
          ) {
            height = parseInt(variableMeta.textarea_height, 10);
          }
          break;
        default:
          height = 60;
      }
    }
    const style = { height: `${height}px` };
    // Variable ref
    let variable_ref = lpApp.references.getVariable(this.props.id);

    // Placeholder
    let placeholder = (variable_ref && variable_ref.placeholder) ? variable_ref.placeholder : "";
    return (
      <div className="form-group">
        <label htmlFor={this.props.lpKey}>
        { this.props.label }
        {' '}
        {'helper' in lpApp.references.getVariable(this.props.id) && lpApp.references.getVariable(this.props.id).helper.length > 0 && <LpHelper text={lpApp.references.getVariable(this.props.id).helper} />}
        </label>
        {(this.props.id in lpApp.references.variables) && lpApp.references.getVariable(this.props.id).warning && <LpWarning text={lpApp.references.getVariable(this.props.id).warning} id={this.props.id} type="v" />}
        <div className="fc-container">
          <textarea id={this.props.lpKey} placeholder={placeholder} className="form-control" style={style} onChange={this.changeCallback} onFocus={this.onFocus} onBlur={this.onBlur} value={this.text} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let value = '';
  let cId;
  let exists = false;
  if (ownProps.isDuplicate) cId = `${ownProps.id}_${ownProps.copy}`;
  else cId = ownProps.id;

  if (ownProps.ovc === 'o') {
    const opt = lpGetOptionById(cId);
    if (typeof opt !== 'undefined') {
      ({ value } = opt);
      exists = true;
    }
  } else {
    const opt = lpGetVariableById(cId);
    if (typeof opt !== 'undefined') {
      ({ value } = opt);
      exists = true;
    }
  }

  /**
   * Prefilling
   */
  if (lpApp.references.variables[ownProps.id].prefillings !== undefined) {
    const { prefillings } = lpApp.references.variables[ownProps.id];
    let executePrefill = (value.length === 0);
    prefillings.forEach((idx) => {
      if (value === idx.text.slice()) executePrefill = true;
    });
    if (prefillings.length !== 0 && executePrefill) {
      for(let i = 0; i < prefillings.length; i++){
        let idx = prefillings[i];
        let text = idx.text.slice();
        let fillForm = false;
        if (idx.compiledConditions.length > 0){
            let id = ownProps.id;
            let parentId = lpApp.indexes.grandpa_vars.getVGrandpa(id);
            let copy = ownProps.copy != -2 ? ownProps.copy : false;
            fillForm = ConditionsEvo.rawCondition(idx.compiledConditions, copy, parentId);
        } else 
            fillForm = true;
        
        if (fillForm) {
          text = text.replace(/\[var:([0-9]+)\]/gi, (a, id) => {
            const variable = lpApp.indexes.variables.getVariable(id);
            const varValue = (variable) ? variable.value.toString() : '';
            return (varValue.trim().length > 0) ? varValue : '________________';
          });
          
          // Looking for old value in prefills
          let foundValueInPrefills = false;
          for(var i = 0; i < prefillings.length; i++){
            if(value == prefillings[i].text){
              foundValueInPrefills = true;
            }
          }

          // Making sure we do not override user input value
          if(foundValueInPrefills === true || value.trim().length === 0){
            value = text;
            break; 
          }
        }
      }
    }
  }

  return {
    value,
    exists,
    sectionId: state.contract.currentSection,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({

  initOutputSystem: (id, parent, genre, value, isDuplicate, copy) => {
    // console.log(genre);
    // check duplication
    const cId = !isDuplicate ? id : `${id}_${copy}`;
    const cPid = !isDuplicate ? parent : `${parent}_${copy}`;

    if (genre === 'o') dispatch(initOutputOption(cId, cPid, value));
    else if (genre === 'v') dispatch(initOutputVariable(cId, cPid, value));
  },
  changeValue: (id, value) => {
    // let cId = !isDuplicate ? id : id + '_' + copy;
    // let cPid = !isDuplicate ? parent : parent + '_' + copy;
    dispatch(editVariable(id, value));
    if (!isDocumentEdited()) dispatch(editedDocument(true));
  },
  updateContext: () => {
    const cId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;
    const pId = ownProps.isDuplicate ? `${ownProps.parent}_${ownProps.copy}` : ownProps.parent;
    if (ownProps.ovc === 'o') dispatch(icSetOption(cId));
    else {
      dispatch(icSetVariable(cId));
      dispatch(icSetOption(pId));
    }
  },
  unUpdateContext: () => {
    if (ownProps.ovc === 'o') dispatch(icSetOption(''));
    else {
      dispatch(icSetVariable(''));
      dispatch(icSetOption(''));
    }
  },

});

const LpTextArea = connect(mapStateToProps, mapDispatchToProps)(TextArea);

export default LpTextArea;



// WEBPACK FOOTER //
// ./src/components/misc/textarea.js